import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { favoriteUpdatesOnOff } from "../AxiosFunctions/Axiosfunctionality";
import { AgentDataAPI } from "../redux/agentSlice";
import { updateMessage, updateOpen } from "../redux/message";
import MyPopup from "../components/myPopup/myPopup";

const tabsAgent = [
  { name: "My Shannon", path: "myHome", tooltip: "home", mgFirst: true },
  {
    name: "My Favorite Artists",
    path: "favoriteArtists",
    tooltip: "",
    mgFirst: false,
  },
  {
    name: "My Idea Boards",
    path: "ideaBoard",
    tooltip: "Create some ideaboards",
    mgFirst: false,
  } /* 
  {
    name: "MyShared Idea Boards",
    path: "sharedIdeaBoard",
    tooltip: "Share some of your ideas.",
  }, */,
];

const HeaderAgentTabs = ({
  agentData,
  activeTab,
  setActiveTab,
  handleContact,
  showButtons = false,
}) => {
  const history = useHistory();
  const [favoriteUpdatesOn, setFavoriteUpdatesOn] = useState(false);
  const [showQuickstartVideo, setShowQuickstartVideo] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (agentData && agentData._id) {
      setFavoriteUpdatesOn(agentData.favoriteUpdatesOn || false);
    }
  }, [agentData]);

  const handleTab = (tabPath) => {
    setActiveTab(tabPath);
    history.push(`/?activeTab=${tabPath}`);
  };

  const handleCheckBox = async () => {
    try {
      const updatedValue = !favoriteUpdatesOn;

      // Optimistically update the UI
      setFavoriteUpdatesOn(updatedValue);

      // Update on the backend
      await favoriteUpdatesOnOff({
        agentId: agentData._id,
        favoriteUpdatesOn: updatedValue,
      });

      dispatch(updateOpen(true));
      dispatch(
        updateMessage(
          `Successfully ${updatedValue ? "enabled" : "disabled"} updates.`
        )
      );
      await dispatch(AgentDataAPI({ _id: agentData._id }));
    } catch (error) {
      console.error("Error updating favorite updates:", error);

      // Optional: Revert toggle on failure
      setFavoriteUpdatesOn(favoriteUpdatesOn); // Roll back state if needed
      dispatch(updateOpen(true));
      dispatch(updateMessage("Failed to update favorite updates."));
    }
  };

  return (
    <>
      <div className="myShannonNavButtons w-100 d-flex justify-content-between align-items-center">
        {agentData?._id ? (
          <div className="d-flex flex-wrap" style={{ gap: "2px" }}>
            {tabsAgent.map((tab, i) => (
              <button
                key={i}
                title={tab.tooltip}
                className={
                  activeTab === tab.path
                    ? "filter-button-black sort-active w-inline-block mt-0"
                    : "filter-button-black w-inline-block mt-0"
                }
                style={{ marginLeft: tab.mgFirst && "0", wordSpacing: "0px" }}
                onClick={() => handleTab(tab.path)}
              >
                {tab.name}
              </button>
            ))}
            <button
              className={
                showQuickstartVideo
                  ? "filter-button-black sort-active w-inline-block mt-0"
                  : "filter-button-black w-inline-block mt-0"
              }
              onClick={() => setShowQuickstartVideo(true)}
            >
              Welcome Tour
            </button>
            <button
              className={
                activeTab === "contact"
                  ? "filter-button-black sort-active w-inline-block mt-0"
                  : "filter-button-black w-inline-block mt-0"
              }
              onClick={() => {
                handleContact();
                handleTab("contact");
              }}
            >
              Contact
            </button>
          </div>
        ) : (
          <div></div>
        )}
        {showButtons && (
          <div className="d-flex align-items-center gap-2 ml-auto">
            <a
              className={
                !agentData || !agentData._id || !activeTab || activeTab === ""
                  ? "filter-button sort-active w-inline-block mt-0"
                  : "filter-button w-inline-block mt-0"
              }
              style={{ marginLeft: "0px" }}
              onClick={() => handleTab("")}
            >
              <div>FEATURED</div>
            </a>
            <a
              className={
                activeTab === "alphabetical"
                  ? "filter-button sort-active w-inline-block mt-0"
                  : "filter-button w-inline-block mt-0"
              }
              onClick={() => handleTab("alphabetical")}
            >
              <div>ALPHABETICAL A-Z</div>
            </a>
          </div>
        )}
      </div>
      {showQuickstartVideo && (
        <MyPopup
          BackClose
          CloseBtn
          onClose={() => setShowQuickstartVideo(false)}
        >
          <video
            title="MyShannon Quickstart Tutorial"
            controls
            style={{
              width: "100%",
              maxHeight: "80vh",
              maxWidth: "80vw",
              objectFit: "contain",
              border: "none",
            }}
            src="/assets/video/COMP_MYSHANONN_INTRO.mp4"
            autoPlay
            type="video/mp4"
          >
            <source
              src="/assets/video/COMP_MYSHANONN_INTRO.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </MyPopup>
      )}
    </>
  );
};

export default HeaderAgentTabs;
